var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-button',{staticStyle:{"font-size":"1.82rem"},attrs:{"theme":"clear"},on:{"click":function($event){return _vm.handleClick()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("")])])}
var staticRenderFns = []

export { render, staticRenderFns }